module.exports = __webpack_public_path__ + "c8375361dc1f622b5961f17312ad15d8.png";